import { Route, Switch } from 'react-router'

import CommonPage from 'app/common/templates/CommonPage'
import { CreateSurvey, SurveyDetails, SurveysList } from 'app/components/Surveys'

export const SurveysPage = () => (
  <CommonPage header="Опросы">
    <Switch>
      <Route exact path="/surveys" component={SurveysList} />
      <Route exact path="/surveys/new" component={CreateSurvey} />
      <Route exact path="/surveys/:surveyId" component={SurveyDetails} />
    </Switch>
  </CommonPage>
)
